import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.16px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.group.approvalMethodTitle};
`;

export const Text = styled.span`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.2px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.subTitle};
`;

export const RadioButtonsContainer = styled.div`
  justify-content: space-between;
  padding: 8px 0 25px 14px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 25px;
`;

export const RadioButtonLabel = styled.div`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.2px;
  margin-left: 12px;
  color: ${({ theme }) => theme.group.subTitle};
`;
